module.exports = __webpack_public_path__ + "static/img/bg8.82551a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg8.jpg
// module id = 4C0l
// module chunks = 1